export const getSubItemDisplayType = (
  subItemGroup: ISubItemGroup
): 'radio' | 'quantity-stepper' => {
  if (subItemGroup.min === 1 && subItemGroup.max === 1) {
    return 'radio';
  }
  return 'quantity-stepper';
};
